import React from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col } from "reactstrap"
import CompanyPoolTable from "../../../components/Lead/companyPool/index.jsx"

const CompanyPoolLeads = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Company Pool | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <CompanyPoolTable />
        </Container>
      </div>
    </React.Fragment>
  )
}
export default CompanyPoolLeads
